import ServicesDetailTablePanel from './services-detail-table-panel.vue';
import ServiceDetail from './service-detail.vue';

export default{
  'services-detail-table-panel': ServicesDetailTablePanel,
  'service-detail': ServiceDetail,
}